<template>
  <form id="money-market-calculator-form" class="form money-market-calculator-form floating-label container px-lg-0 px-sm-3" @submit.prevent="calculate()">
    <div :class="formInitial || recalculate ? 'money-market-calculator-form-single-column' : 'moneymarket-calculator-form-multi-column row justify-content-around'">
        <div :class="formInitial || recalculate ? 'col-sm-12 col-md-12 px-0' : 'pr-md-5 pr-lg-5 col-sm-12 col-lg-5 w-print-lg'">
          <div :class="formInitial || recalculate ? 'row justify-content-center' : 'row'">
            <!-- Price Input Field -->
            <div :class="formInitial || recalculate ? 'col-lg-6 col-md-8 col-sm-12' : 'col-md-12 col-sm-12'">
              <div class="form-group mb-md-4">
                <div :class="zipcodeModel !== '' ? 'floating-label is-floating' : 'floating-label'">
                  <label for="zipcode-field">ZIP Code</label>
                  <input ref="ziplocation"
                         id="zipcode-field"
                         placeholder=""
                         name="zipcode-field"
                         autocapitalize="off"
                         autocomplete="off"
                         spellcheck="false"
                         aria-label="zip code"
                         maxlength="5"
                         class="form-control money-market-zipcode-input"
                         @blur="toggleLabel($event)"
                         @focus="toggleLabel($event)"
                         v-model="zipcodeModel"
                         type="text"
                         @keypress="onlyNumber"
                         @keydown.enter="calculate()"
                         @keyup="clearInput()" />
                  <div class="money-market-calculator-form__error-message" v-show="zipCodeLessThanFive">ZIP CODE IS REQUIRED.</div>
                  <div class="money-market-calculator-form__error-message" v-show="errored">
                     <div v-html="zipcodelocationerror"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :class="formInitial || recalculate ? 'row justify-content-center' : 'row'">
            <div :class="formInitial || recalculate ? 'col-md-6 col-sm-12' : 'col-md-12 col-sm-12'">
              <div :class="formInitial || recalculate ? 'form-group d-flex justify-content-center' : 'form-group d-flex justify-content-center justify-content-lg-start'">
                <button :class="formInitial || recalculate ? 'btn btn-primary btn-wide btn-pill btn-moneymarket-submit' : 'btn btn-primary btn-wide btn-pill btn-moneymarket-recalc'" type="submit" >
                  <span class="money-market-label" v-if="!loading">Get rates</span>
                  <div class="money-market-calculator-form__loading" v-else>
                    <div class="money-market-calculator-form__spinner"></div>
                    Loading...
                  </div>
                </button>
              </div>
            </div>
        </div>
        <div v-show="!isMobile && !formInitial" :class="!formInitial && !recalculate ? 'row money-market-disclaimer-container' : 'row money-market-disclaimer-container justify-content-center'">
          <div :class="!formInitial && !recalculate ? 'col-md-12 col-sm-12' : 'col-md-12 col-sm-12'">
            <hr class="money-market-calculator-form__separator" />
            <div v-html="disclaimer"></div>
          </div>
        </div>
      </div>
        <div :class="formInitial || recalculate ? 'col-sm-12 col-md-12' : 'col-sm-12 col-lg-6 w-print-lg px-0 '">
          <div v-if="!formInitial && loadedPercentage" class="col-sm-12 col-lg-12 w-print-lg px-0">
            <div v-if="loadedPercentage" class="row money-market-calculator-form__percent mx-0 mt-lg-0">
              <div class="col-md-12 d-flex justify-content-center align-items-start px-0">
                <h2 class="fs-5 money-market-calculator-form__percent-calc">
                  <AnimatedNumber :value="firstRate" :duration="1000" :formatValue="formatToPrice" />
                  <span class="mx-2">–</span>
                  <AnimatedNumber :value="lastRate" :duration="1000" :formatValue="formatToPrice" />
                </h2>
                <div class="money-market-calculator-form__percentInfo pr-1">
                  <div class="money-market-calculator-form__percentInfo-sign">%</div>
                </div>
                <p class="fs-5 money-market-calculator-form__percent-apy">
                  <span>APY</span>
                </p>
              </div>
            </div>

            <div v-show="!formInitial" :class="!formInitial && !recalculate ? 'row money-market-disclaimer-container flex-nowrap mx-0 w-100 justify-content-center' : 'row money-market-disclaimer-container justify-content-center'">
              <div class="text-right px-0" v-if="depositTiers.length > 0">
                <h3 class="money-market-calculator-form__deposit-tier-title mb-3 mb-lg-4">Deposit Tier</h3>
                <ul class="list-unstyled">
                  <li v-for="depositTier in depositTiers" :key="depositTier" class="money-market-calculator-form__deposit-tier-list">
                    {{ depositTier }}
                  </li>
                </ul>
              </div>
              <div class="text-left pr-0 pl-4" v-if="formattedRates.length > 0">
                <h3 class="money-market-calculator-form__deposit-tier-title mb-3 mb-lg-4">APY</h3>
                <ul class="list-unstyled">
                  <li v-for="(formattedRate, index) in formattedRates" :key="index" class="money-market-calculator-form__deposit-tier-list">
                    {{ formattedRate }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div v-show="!formInitial && !loadedPercentage && errored" v-html="defaultvalue" class="moneymarket-default-value"></div>
        </div>
        <div v-show="isMobile && !formInitial" :class="!formInitial && !recalculate ? 'row money-market-disclaimer-container mx-0' : 'row money-market-disclaimer-container justify-content-center'">
          <div :class="!formInitial && !recalculate ? 'col-md-12 col-sm-12' : 'col-md-12 col-sm-12'">
            <hr class="money-market-calculator-form__separator" />
            <div v-html="disclaimer"></div>
          </div>
        </div>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import AnimatedNumber from "../../../components/AnimatedNumber.vue";

export default {
  data() {
    return {
      errored: false,
      index: 0,
      loading: false,
      loaded: false,
      radius: 5,
      zipcodeModel: "",
      zipRangeCondition: false,
      zipErrorForm: false,
      formSended: false,
      formInitial: true,
      loadedPercentage: true,
      recalculate: false,
      axiosAbortController: new AbortController(),
      zipCodeLessThanFive: false,
      firstRate: 0,
      lastRate: 0,
      mmRatesData: [],
      mmRatesRange: [],
      depositTiers: [],
      formattedRates: []
    }
  },
  components: {
    AnimatedNumber
  },
  computed: {
    isMobile() {
      return this.$mq != "desktop";
    },
    isIOSorAndroid() {
      if (/iPad|iPhone|iPod/.test(navigator.userAgent) || /(android)/i.test(navigator.userAgent)) {
        return true;
      } else {
        return navigator.maxTouchPoints &&
          navigator.maxTouchPoints > 2 &&
          /MacIntel/.test(navigator.platform);
      }
    }
  },
  methods: {
    checkZipCode() {
      let condition = this.zipcodeModel && /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(this.zipcodeModel);
      if (condition) {
        this.zipCodeLessThanFive = false;
      } else {
        this.zipCodeLessThanFive = true;
      }
    },
    formatToPrice(value) {
      const num = Number(value)
      return isNaN(num) ? '0.00' : `${num.toFixed(2)}`
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault()
      }
    },
    calculateDepositTiers() {
      return this.mmRatesRange.map(item => {
        const low = Number(item.low).toLocaleString();
        if (item.low === '1000000' || item.low === '1000000.00') {
          return "$1,000,000+";
        } else {
          const high = Number(item.high).toLocaleString();
          return `$${low} – $${high}`;
        }
      });
    },
    clearInput() {
      this.zipRangeCondition = false
      this.zipErrorForm = false
    },
    async calculate() {
      this.checkZipCode();
      this.errored = false;
      let inputValue = this.zipcodeModel;
      if (!this.zipCodeLessThanFive && !isNaN(inputValue)) {
        // Reset rates to 0 before starting the API call to ensure animation starts from 0
        this.firstRate = 0;
        this.lastRate = 0;
        this.loading = true
        this.formSended = true;
        this.getMMRates(inputValue)
      }
    },
    async getMMRates(zipcode) {
      this.axiosAbortController.abort();
      this.axiosAbortController = new AbortController();

      let mmRatesApi = "/api/mm-rates?zipcode=" + zipcode

      axios
        .get(mmRatesApi, { signal: this.axiosAbortController.signal })
        .then((response) => {
          this.mmRatesData = response.data
          this.mmRatesRange = response.data.tiers

          if (!this.mmRatesRange || this.mmRatesRange?.length <= 0) {
            this.errored = true
            this.loading = false  
            this.firstRate = '0.00'
            this.lastRate = '0.00'
            this.depositTiers = []
            this.formattedRates = []
            this.loadedPercentage = false
          } else {
            this.zipCodeLessThanFive = false
            this.formSended = true
            this.loading = false
            this.errored = false
            this.formInitial = false
            this.recalculate = false
            this.isMinimumValue = true
            this.loadedPercentage = true
            
            this.depositTiers = this.calculateDepositTiers();
            this.formattedRates = this.mmRatesRange.map(item => `${(item.rate * 100).toFixed(2)}%`);
            
            // Set the rate values to trigger animation
            this.$nextTick(() => {
              this.firstRate = this.mmRatesRange[0].rate * 100;
              this.lastRate = this.mmRatesRange[this.mmRatesRange.length - 1].rate * 100;
            })
          }
        })
        .catch((error) => {
          this.errored = true
        })
    },
    toggleLabel(event) {
      if (event.type === "focus") {
        this.zipCodeLessThanFive = false;
        event.target.parentElement.classList.add("has-focus")
        event.target.parentElement.classList.add("is-floating")
      }
      if (event.type === "blur") {
        event.target.parentElement.classList.remove("has-focus")
        if (event.target.value === "") {
          event.target.parentElement.classList.remove("is-floating")
        }
      }
    }
  },
  props: {
    disclaimer: String,
    defaultvalue: String,
    zipcodelocationerror: String
  }
}
</script>
